import React, { useRef, useState, useEffect } from "react";
import { Container, Row, Col, Card, ProgressBar } from 'react-bootstrap';
import ArrowRight from '../../assets/svg/RightArrow.svg';
import Uparrow from '../../assets/svg/Uparrow-Green.svg';
import Downarrow from '../../assets/svg/DownArrow.svg';
import Active from '../../assets/svg/Active.svg';
import Inactive from '../../assets/svg/Inactive.svg';
import left from '../../assets/svg/left.svg';
import right from '../../assets/svg/right.svg';
import right1 from '../../assets/svg/right1.svg';
import left1 from '../../assets/svg/left1.svg';

import { Doughnut } from 'react-chartjs-2';

import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  ArcElement,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

import { getCountApi, getExternalOverviewApi, getStatusOverviewApi } from './dashboard-api'
import { useNavigate } from 'react-router-dom';


ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend, ArcElement);


const Dashboard = () => {

  const [ConfigCount, setConfigCount] = useState([]);

  const [internalData, setInternalData] = useState({ running: 0, total: 0, percentage: 0 });
  const [externalData, setExternalData] = useState({ running: 0, total: 0, percentage: 0 });

  const [exOverview, setExOverViewCount] = useState([]);
  const [deviceData, setDeviceData] = useState({
    active: { count: 0, last_update: '' },
    inactive: { count: 0, last_update: '' },
    history: []
  });
  const navigate = useNavigate();
  useEffect(() => {
    getCountDetials();
    getExternalOverview();
    getStatusOverview();
  }, []);

  const getCountDetials = async () => {
    try {
      const response = await getCountApi();
      if (response.data.success === true) {
        setConfigCount(response.data.count);
        console.log(response.data.count);
        const data = response.data.count;

        const internal = data.application.internal;
        const external = data.application.external;

        setInternalData({
          running: internal.running,
          overall: internal.overall,
          percentage: internal.overall > 0
            ? Math.round((internal.running / internal.overall) * 100)
            : 0
        });

        setExternalData({
          running: external.running,
          overall: external.overall,
          percentage: external.overall > 0
            ? Math.round((external.running / external.overall) * 100)
            : 0
        });
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };

  const getExternalOverview = async () => {
    try {
      const response = await getExternalOverviewApi();
      if (response.data.success === true) {
        setExOverViewCount(response.data.data);
      }
    } catch (err) {
      console.error("Error fetching external overview:", err);
    }
  };

  // Extract data
  const embeddedLinks = exOverview?.embedded?.count || 0;
  const widgets = exOverview?.widget?.count || 0;
  const durationEmbedded = exOverview?.embedded?.duration || 0;
  const durationWidgets = exOverview?.widget?.duration || 0;
  const updatedEmbedded = exOverview?.embedded?.updated_at;
  const updatedWidgets = exOverview?.widget?.updated_at;
  const total = embeddedLinks + widgets;

  // Format timestamp
  const formatTime = (timestamp) => {
    if (!timestamp) return '-- --';
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  //Get Device Status OverView Api
  const getStatusOverview = async () => {
    try {
      const response = await getStatusOverviewApi();
      if (response.data.success === true) {
        setDeviceData(response.data);
        console.log(response.data);
      }
    } catch (err) {
      console.error("Error fetching status overview:", err);
    }
  };

  const activeData = deviceData.history.map(item => item.active_count);
  const inactiveData = deviceData.history.map(item => -item.inactive_count);
  const labels = deviceData.history.map(item =>
    new Date(item.updated_date).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
  );


  const lastUpdate = deviceData.active.last_update
    ? new Date(deviceData.active.last_update).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    : '--';

  // Chart config
  const sccdata = {
    labels: ['Embedded Links', 'Widgets'],
    datasets: [
      {
        data: [embeddedLinks, widgets],
        backgroundColor: ['#F1583C', '#F4D25E'],
        borderWidth: 0,
        cutout: '60%',
        borderRadius: 0,
        spacing: 5
      },
    ],
  };

  const sccoptions = {
    rotation: -90,
    circumference: 180,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: true
      }
    },
  };
  // circular chart 1
  const ccdata = {
    datasets: [
      {
        data: [internalData.percentage, 100 - internalData.percentage],
        backgroundColor: ['#F1583C', '#eee'],
        borderWidth: 0,
        cutout: '70%',
        hoverOffset: 0,
      },
    ],
  };
  // circular chart 2
  const cc2data = {
    datasets: [
      {
        data: [externalData.percentage, 100 - externalData.percentage],
        backgroundColor: ['#F4D25E', '#eee'],
        borderWidth: 0,
        cutout: '70%',
        hoverOffset: 0,
      },
    ],
  };

  const ccoptions = {
    plugins: {
      tooltip: { enabled: true },
    },
    responsive: false,
    maintainAspectRatio: false,
  };


  return (
    <Container fluid className="px-0" style={{ backgroundColor: "#F5F7F9", paddingBottom: "10px", fontFamily: 'DM Sans' }}>
      <Row className="px-4 py-2" style={{ padding: '10px' }}>
        <Col xs={12} style={{ padding: '20px', backgroundColor: '#FFFFFF', borderRadius: "16px", display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <div style={{ fontSize: '24px', fontWeight: '500', color: '#21272C' }}>Signage overview</div>
            <div style={{ fontSize: '15px', color: '#66737E', marginTop: '5px', fontWeight: 400 }}>Here you can see your overall signage overview and it's entire process in the single screen</div>
          </div>
          <div>
            <select style={{
              padding: '1px 16px', borderRadius: '62px', backgroundColor: "#F5F7F9", fontSize: "14px", fontWeight: 500, height: "40px", border: "none", appearance: 'none', backgroundImage: 'url("data:image/svg+xml;utf8,<svg fill=\'%23262626\' height=\'20\' viewBox=\'0 0 24 24\' width=\'20\' xmlns=\'http://www.w3.org/2000/svg\'><path d=\'M7 10l5 5 5-5z\'/></svg>")', backgroundRepeat: 'no-repeat', backgroundPosition: 'right 12px center', backgroundSize: '14px', paddingRight: '36px'
            }}>
              <option value="all">This year</option>
              <option value="gate1">This Month</option>
              <option value="gate2">This Week</option>
            </select>
          </div>
        </Col>
      </Row>

      <Row style={{ margin: 0, rowGap: '10px' }} className="g-2 px-2 py-2">
        {/* Devices Card */}
        <Col xs={12} sm={6} md={2}>
          <div style={{
            backgroundColor: '#FFFFFF',
            padding: '10px',
            borderRadius: '16px',
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
              <span style={{ width: "3px", height: "10px", backgroundColor: "#F1583C" }}></span>
              <span style={{ color: '#000', fontWeight: 400, fontSize: "16px" }}>Devices</span>
              {ConfigCount?.device && (
                <span style={{ backgroundColor: ConfigCount.device.is_low ? '#FEF1F1' : '#F1FEF3', color: ConfigCount.device.is_low ? '#F1583C' : '#01B713', fontSize: '12px', fontWeight: 700, padding: '4px 10px', borderRadius: '35px', display: 'flex', alignItems: 'center' }}>
                  <img
                    src={ConfigCount.device.is_low ? Downarrow : Uparrow}
                    alt="Arrow"
                    style={{ width: 12, height: 12, marginRight: 4 }}
                  />
                  {Math.abs(ConfigCount.device.diff)}%
                </span>
              )}
            </div>

            <div style={{ display: 'flex', alignItems: 'center', fontSize: '36px', fontWeight: 500, color: '#000000', marginBottom: '8px', }}>
              {ConfigCount?.device?.count ?? '-'}
              <img src={ArrowRight} alt="Arrow Right" style={{ marginLeft: 15, width: 34, height: 34, backgroundColor: "#F5F7F9", borderRadius: "50%", padding: 10 }} onClick={() => navigate('/devices')} />
            </div>

            <div style={{ fontSize: '14px', fontWeight: 400, color: '#66737E', }}>
              Last Update at {ConfigCount?.device?.last_update ?? '--'}
            </div>
          </div>
        </Col>

        {/* Groups Card */}
        <Col xs={12} sm={6} md={2}>
          <div style={{ backgroundColor: '#FFFFFF', padding: '10px', borderRadius: '16px', }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
              <span style={{ width: "3px", height: "10px", backgroundColor: "#F1583C" }}></span>
              <span style={{ color: '#000', fontWeight: 400, fontSize: "16px" }}>Groups</span>
              {ConfigCount?.group && (
                <span style={{ backgroundColor: ConfigCount.group.is_low ? '#FEF1F1' : '#F1FEF3', color: ConfigCount.group.is_low ? '#F1583C' : '#01B713', fontSize: '12px', fontWeight: 700, padding: '4px 10px', borderRadius: '35px', display: 'flex', alignItems: 'center' }}>
                  <img src={ConfigCount.group.is_low ? Downarrow : Uparrow} alt="Arrow" style={{ width: 12, height: 12, marginRight: 4 }} />
                  {Math.abs(ConfigCount.group.diff)}%
                </span>
              )}
            </div>

            <div style={{ display: 'flex', alignItems: 'center', fontSize: '36px', fontWeight: 500, color: '#000000', marginBottom: '8px', }}>
              {ConfigCount?.group?.count ?? '-'}

              <img src={ArrowRight} alt="Arrow Right" style={{ marginLeft: 15, width: 34, height: 34, backgroundColor: "#F5F7F9", borderRadius: "50%", padding: 10 }} onClick={() => navigate('/group')} />

            </div>

            <div style={{ fontSize: '14px', fontWeight: 400, color: '#66737E', }}>
              Last Update at {ConfigCount?.group?.last_update ?? '--'}
            </div>
          </div>
        </Col>

        {/* Internal Applications */}
        <Col xs={12} sm={6} md={4}>
          <div style={{ backgroundColor: '#FFFFFF', padding: '10px', borderRadius: '16px', padding: '10px', borderRadius: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{ fontSize: '16px', fontWeight: 400, color: '#21272C', marginBottom: '12px', }}>Running Internal Applications</div>
              <div style={{ fontSize: '36px', fontWeight: 500, color: '#000000', marginBottom: '8px', marginBottom: '12px' }}>{internalData.running}</div>
              <div style={{ fontSize: '14px', fontWeight: 400, color: '#66737E', }}>Last Update at {internalData.last_update ?? '--'}
              </div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ width: 80, height: 80, position: 'relative' }}>
                <Doughnut data={ccdata} options={ccoptions} width={80} height={80} />
                <div style={{ position: 'absolute', top: '60%', left: '50%', transform: 'translate(-50%, -50%)', fontSize: '16px', fontWeight: 500, color: '#21272C', }}>{internalData.percentage}%</div>
              </div>
              <div style={{ marginTop: '4px', fontSize: '14px', fontWeight: 400, color: '#21272C' }}>
                <strong>{internalData.overall}</strong> applications
              </div>
            </div>
          </div>
        </Col>

        {/* External Applications */}
        <Col xs={12} sm={6} md={4}>
          <div style={{ backgroundColor: '#FFFFFF', padding: '10px', borderRadius: '16px', padding: '10px', borderRadius: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{ fontSize: '16px', fontWeight: 400, color: '#21272C', marginBottom: '12px', }}>Running External Applications</div>
              <div style={{ fontSize: '36px', fontWeight: 500, color: '#000000', marginBottom: '8px', marginBottom: '12px' }}>{externalData.running}</div>
              <div style={{ fontSize: '14px', fontWeight: 400, color: '#66737E', }}>Last Update at {externalData.last_update ?? '--'}</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ width: 80, height: 80, position: 'relative' }}>
                <Doughnut data={cc2data} options={ccoptions} width={80} height={80} />
                <div style={{ position: 'absolute', top: '60%', left: '50%', transform: 'translate(-50%, -50%)', fontSize: '16px', fontWeight: 500, color: '#21272C', }}>{externalData.percentage}%</div>
              </div>
              <div style={{ marginTop: '4px', fontSize: '14px', fontWeight: 400, color: "#21272C" }}>
                <strong>{externalData.overall}</strong> applications
              </div>
            </div>
          </div>
        </Col>

      </Row>

      <Row className="" style={{ padding: '10px' }}>
        <Col lg={7}>
          <div style={{ backgroundColor: '#FFFFFF', padding: '20px', borderRadius: '16px', display: 'flex', flexDirection: 'column' }}>
            <div style={{ fontWeight: '500', fontSize: '20px', marginBottom: '10px' }}>
              External overview
            </div>

            <div style={{ padding: "16px", backgroundColor: "#F5F7F9", borderRadius: '40px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', backgroundColor: '#FFFFFF', borderRadius: '24px', padding: '10px' }}>
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                  <div style={{ width: '170px', height: '90px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0' }}>
                    <Doughnut data={sccdata} options={sccoptions} />
                  </div>


                  <div style={{ marginTop: '-30px', fontSize: '24px', fontWeight: 600 }}>{total}</div>
                  <div style={{ fontSize: '14px', fontWeight: 400, color: '#666', borderBottom: "1px dashed #D4DDE7", marginBottom: '8px' }}> Total count </div>

                  <div style={{ marginTop: '12px', fontSize: '14px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '6px' }}>
                    <div>
                      <span style={{ width: '12px', height: '12px', backgroundColor: '#F1583C', borderRadius: '4px', marginRight: '8px', display: 'inline-block' }}></span>                      Embedded Links                    </div>
                    <div>
                      <span style={{ width: '12px', height: '12px', backgroundColor: '#F4D25E', borderRadius: '4px', marginRight: '8px', display: 'inline-block' }}></span>                      Widgets                    </div>
                  </div>
                </div>


                {/* Middle - Embedded Links */}
                <div style={{ flex: 1, borderLeft: '1px solid #D4DDE7', paddingLeft: '16px' }}>
                  <div style={{ fontWeight: 700, marginBottom: '8px', fontSize: "14px" }}>Embedded Links</div>
                  <div style={{ fontSize: '32px', fontWeight: 500 }}>{embeddedLinks}</div>
                  <div style={{ fontSize: '14px', color: '#66737E', marginBottom: '8px', fontWeight: 400 }}>
                    Last Update at {formatTime(updatedEmbedded)}
                  </div>
                  <div style={{ backgroundColor: '#F5F7F9', borderRadius: '100px', display: 'inline-block', padding: '4px 12px', fontSize: '14px', fontWeight: 500, color: '#21272C' }}>
                    Duration <strong style={{ marginLeft: '6px' }}>{durationEmbedded}</strong>
                  </div>
                </div>

                {/* Right - Widgets */}
                <div style={{ flex: 1, borderLeft: '1px solid #D4DDE7', paddingLeft: '16px' }}>
                  <div style={{ fontWeight: 700, marginBottom: '8px', fontSize: "14px" }}>Widgets</div>
                  <div style={{ fontSize: '32px', fontWeight: 500 }}>{widgets}</div>
                  <div style={{ fontSize: '14px', color: '#66737E', marginBottom: '8px', fontWeight: 400 }}>
                    Last Update at {formatTime(updatedWidgets)}
                  </div>
                  <div style={{ backgroundColor: '#F5F7F9', borderRadius: '100px', display: 'inline-block', padding: '4px 12px', fontSize: '14px', fontWeight: 500, color: '#21272C' }}>
                    Duration <strong style={{ marginLeft: '6px' }}>{durationWidgets}</strong>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </Col>
        <Col lg={5}>
          <div style={{ backgroundColor: '#FFFFFF', padding: '20px', borderRadius: '24px', margin: '0 auto', color: "#21272C" }}>
            <div style={{ fontWeight: 500, fontSize: '20px', marginBottom: '10px' }}>
              Devices status overview
            </div>

            <div style={{ display: 'flex', gap: '10px', marginBottom: '14px' }}>
              {/* Active */}
              <div style={{ backgroundColor: '#FFF2EF', borderRadius: '24px', flex: 1, padding: '10px', textAlign: 'center', position: 'relative' }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <img src={left} alt="Active" />
                  <div style={{ backgroundColor: '#F1583C', width: '40px', height: '40px', borderRadius: '50%', display: "flex", justifyContent: 'center', alignItems: "center" }}>
                    <img src={Active} alt="Active" />
                  </div>
                  <img src={right} alt="Active" />
                </div>

                <div style={{ fontWeight: 400, fontSize: "14px" }}>Active devices</div>
                <div style={{ fontSize: '28px', fontWeight: 500 }}>{deviceData.active.count}</div>
                <div style={{ fontSize: '12px', color: '#66737E', fontWeight: 400 }}>Last Update at {lastUpdate}</div>
              </div>

              {/* Inactive */}
              <div style={{ backgroundColor: '#FFFBEE', borderRadius: '20px', flex: 1, padding: '10px', textAlign: 'center', position: 'relative' }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <img src={left1} alt="Inactive" />
                  <div style={{ backgroundColor: '#F4D25E', width: '40px', height: '40px', borderRadius: '50%', display: "flex", justifyContent: 'center', alignItems: "center" }}>
                    <img src={Inactive} alt="Inactive" />
                  </div>
                  <img src={right1} alt="Inactive" />
                </div>

                <div style={{ fontWeight: 400, fontSize: "14px" }}>Inactive devices</div>
                <div style={{ fontSize: '28px', fontWeight: 500 }}>{deviceData.inactive.count}</div>
                <div style={{ fontSize: '12px', color: '#66737E', fontWeight: 400 }}>Last Update at {lastUpdate}</div>
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '10px' }}>
              <div style={{ height: '80px', width: '70%', borderRight: '1px dashed #D4DDE7' }}>
                {/* For testing, use sampleHistoryData */}
                <ManualBarChart history={deviceData.history} />
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '0px' }}>
                <div style={{ display: 'flex', alignItems: 'center', fontSize: '14px', marginBottom: '8px' }}>
                  <div style={{ width: '12px', height: '12px', backgroundColor: '#F1583C', borderRadius: '4px', marginRight: '8px' }}></div>
                  Active
                  <div style={{ marginLeft: 'auto', fontWeight: 600 }}>
                    {activeData.reduce((sum, val) => sum + val, 0)}
                  </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', fontSize: '14px' }}>
                  <div style={{ width: '12px', height: '12px', backgroundColor: '#F4D25E', borderRadius: '4px', marginRight: '8px' }}></div>
                  Inactive
                  <div style={{ marginLeft: 'auto', fontWeight: 600 }}>
                    {inactiveData.reduce((sum, val) => sum + Math.abs(val), 0)}
                  </div>
                </div>

                <div style={{ fontSize: '12px', color: '#888', marginTop: '8px' }}>
                  On {deviceData.history.length ? deviceData.history[deviceData.history.length - 1].updated_date : '--'}
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Dashboard;

const ManualBarChart = ({ history: historyData }) => {
  // Filter out bars where both counts are 0
  const filtered = historyData.filter(item => item.active_count !== 0 || item.inactive_count !== 0);
  const maxCount = Math.max(...filtered.map(h => Math.max(h.active_count, h.inactive_count)), 1);

  // Always show 10 bars, center if less
  const barsToShow = 10;
  let bars = filtered.slice(-barsToShow);
  if (bars.length < barsToShow) {
    const emptyBars = Array.from({ length: barsToShow - bars.length }, () => ({
      active_count: 0,
      inactive_count: 0,
      updated_date: ''
    }));
    // Center the bars
    const leftPad = Math.floor(emptyBars.length / 2);
    const rightPad = emptyBars.length - leftPad;
    bars = [
      ...emptyBars.slice(0, leftPad),
      ...bars,
      ...emptyBars.slice(leftPad)
    ];
  }

  // Tooltip state
  const [tooltip, setTooltip] = useState({ show: false, x: 0, y: 0, barIndex: null, type: null });
  const chartRef = useRef();

  // Tooltip render
  const renderTooltip = () =>
    tooltip.show && tooltip.barIndex !== null ? (
      <div
        style={{ position: 'fixed', left: tooltip.x + 10, top: tooltip.y - 30, background: '#21272C', color: '#fff', padding: '6px 12px', borderRadius: 6, fontSize: 13, pointerEvents: 'none', zIndex: 10000, boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}      >
        <div>
          <div style={{ fontWeight: 600, marginBottom: 2 }}>
            {bars[tooltip.barIndex]?.updated_date || '--'}
          </div>
          <div>
            <span style={{ color: '#F1583C', fontWeight: 500 }}>Active:</span> {bars[tooltip.barIndex]?.active_count}
          </div>
          <div>
            <span style={{ color: '#F4D25E', fontWeight: 500 }}>Inactive:</span> {bars[tooltip.barIndex]?.inactive_count}
          </div>
        </div>
      </div>
    ) : null;

  return (
    <div
      ref={chartRef}
      style={{ display: 'flex', overflowX: 'auto', alignItems: 'flex-end', height: '100px', padding: '10px', gap: '6px', borderRadius: '8px', background: '#fff', position: 'relative' }} onMouseLeave={() => setTooltip({ ...tooltip, show: false, barIndex: null, type: null })}    >
      {/* Center line */}
      <div
        style={{ position: 'absolute', left: 0, right: 0, top: '50%', height: 3, background: '#ffffff', zIndex: 999 }} />
      {bars.map((item, i) => {
        const isLast = i === bars.length - 1;
        const activeHeight = (item.active_count / maxCount) * 40;
        const inactiveHeight = (item.inactive_count / maxCount) * 40;

        // Highlight logic
        const highlightActive = tooltip.show && tooltip.barIndex === i && tooltip.type === 'active';
        const highlightInactive = tooltip.show && tooltip.barIndex === i && tooltip.type === 'inactive';

        return (
          <div
            key={i}
            style={{ width: '6px', height: '80px', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', position: 'relative', zIndex: 1 }}          >
            {/* Spacer to push active bar to center */}
            <div style={{ height: `${40 - activeHeight}px`, width: '6px' }} />
            {/* Active bar (upwards from center) */}
            <div
              style={{
                width: '6px',
                height: `${activeHeight}px`,
                borderRadius: '3px 3px 0 0',
                backgroundColor: highlightActive
                  ? '#F1583C'
                  : isLast
                    ? '#F1583C'
                    : '#D4DDE7',
                transition: '0.3s',
                cursor: item.active_count ? 'pointer' : 'default'
              }}
              onMouseEnter={e => {
                if (item.active_count) {
                  setTooltip({
                    show: true,
                    x: e.clientX,
                    y: e.clientY,
                    barIndex: i,
                    type: 'active'
                  });
                }
              }}
              onMouseMove={e => {
                if (item.active_count && tooltip.barIndex === i && tooltip.type === 'active') {
                  setTooltip(t => ({ ...t, x: e.clientX, y: e.clientY }));
                }
              }}
              onMouseLeave={() => setTooltip({ ...tooltip, show: false, barIndex: null, type: null })}
            />
            {/* Center line overlap (transparent, for spacing) */}
            <div style={{ height: '1px', width: '6px' }} />
            {/* Inactive bar (downwards from center) */}
            <div
              style={{
                width: '6px',
                height: `${inactiveHeight}px`,
                borderRadius: '0 0 3px 3px',
                backgroundColor: highlightInactive
                  ? '#F4D25E'
                  : isLast
                    ? '#F4D25E'
                    : '#D4DDE7',
                transition: '0.3s',
                cursor: item.inactive_count ? 'pointer' : 'default'
              }}
              onMouseEnter={e => {
                if (item.inactive_count) {
                  setTooltip({
                    show: true,
                    x: e.clientX,
                    y: e.clientY,
                    barIndex: i,
                    type: 'inactive'
                  });
                }
              }}
              onMouseMove={e => {
                if (item.inactive_count && tooltip.barIndex === i && tooltip.type === 'inactive') {
                  setTooltip(t => ({ ...t, x: e.clientX, y: e.clientY }));
                }
              }}
              onMouseLeave={() => setTooltip({ ...tooltip, show: false, barIndex: null, type: null })}
            />
            {/* Spacer to fill remaining height */}
            <div style={{ flex: 1 }} />
          </div>
        );
      })}
      {renderTooltip()}
    </div>
  );
};


